<template>
    <DCard
        padding
    >
        <DTable
            :items="customerSegments"
            :fields="[
                {key: 'id', label: __('settings.customer-segments.index.table.headers.id'), _classes: 'id'},
                {key: 'name', label: __('settings.customer-segments.index.table.headers.name'), _classes: 'name'},
                {key: 'active', label: __('settings.customer-segments.index.table.headers.active'), _classes: 'active'},
                {key: 'actions', label: '', sorter: false, filter: false},
            ]"
            hover
            sorter
        >
            <template #active="{item}">
                <td>
                    <DBadge :color="item.active ? 'success' : 'secondary'">
                        {{ item.active ? __('settings.customer-segments.index.table.values.active.yes') : __('settings.customer-segments.index.table.values.active.no') }}
                    </DBadge>
                </td>
            </template>

            <template #actions="{item}">
                <td>
                    <div class="actions">
                        <DButton
                            v-if="!item.active"
                            :id="`activate_${item.id}`"
                            :disabled="isInLoadingState"
                            icon="arrow-up-circle-outline"
                            :label="__('settings.customer-segments.index.table.action.activate')"
                            @click="activateCustomerSegments(item.id)"
                        />
                        <DButton
                            v-if="item.active"
                            :id="`deactive_${item.id}`"
                            :disabled="isInLoadingState"
                            icon="arrow-down-circle-outline"
                            :label="__('settings.customer-segments.index.table.action.deactivate')"
                            @click="deactivateCustomerSegments(item.id)"
                        />
                        <DButton
                            :id="`edit_${item.id}`"
                            :disabled="isInLoadingState"
                            icon="pencil"
                            @click="editCustomerSegments(item.id)"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            :disabled="shouldDisableDeletion(item) || isInLoadingState"
                            icon="trash-can-outline"
                            color="danger"
                            @click="destroyCustomerSegments(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.customer-segments.index.add_button')"
                @click="$inertia.get($route('settings.customer-segments.create'))"
            />
        </DFabs>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.customer-segments.index.deleteConfirmation.title')"
            :message="__('settings.customer-segments.index.deleteConfirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'CustomerSegmentsIndex',
    props: {
        customerSegments: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    methods: {
        activateCustomerSegments (id) {
            this.$inertia.post(this.$route('settings.customer-segments.activate', id))
        },
        deactivateCustomerSegments (id) {
            this.$inertia.post(this.$route('settings.customer-segments.deactivate', id))
        },
        destroyCustomerSegments (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.customer-segments.destroy', id))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        editCustomerSegments (id) {
            this.$inertia.get(this.$route('settings.customer-segments.edit', id))
        },
        shouldDisableDeletion (item) {
            return item.inUse
        }
    }
}
</script>

<style lang="scss" scoped>
.actions {
    display: flex;
    grid-gap: 10px;
    justify-content: flex-end;
}
</style>
